<template>
  <div class="site-footer w-screen bg-slate-lighter text-base text-slate-darker">
    <!-- CTA on top via CtaBanner -->
    <div v-if="ctaProps" class="px-4 pt-4 md:px-10 md:pt-16">
      <cta-banner :cta-data="ctaProps" theme="default" variant="default" />
    </div>

    <div
      class="first-block mx-8 my-16 flex flex-col justify-center border-b border-t border-solid border-purple-lightest py-16 md:mx-0 md:mx-0 md:my-20 md:flex-row md:justify-around md:px-10 md:pt-10 md:pt-20"
    >
      <div class="max-w-[650px]">
        <h2 class="mb-4 font-headline text-h2 text-slate-darker">Rädda Djuren-klubben</h2>

        <ContentfulRichText
          v-if="footerBody"
          class="max-w-lg text-body [&_a]:text-purple-dark [&_a]:underline"
          :document="footerBody"
        />

        <ul class="mt-5 flex flex-col md:mt-10">
          <li
            class="before:duration-400 relative pl-5 font-body font-bold leading-[21px] text-purple-dark-base before:absolute before:left-0 before:top-1 before:h-2 before:w-2 before:rotate-[-45deg] before:rounded-sm before:border-b-2 before:border-r-2 before:border-solid before:border-purple-dark-base before:transition-all before:content-[''] hover:before:translate-x-0.5 hover:before:translate-x-0.5"
          >
            <nuxt-link class="link p-0" to="https://www.raddadjuren.se/om-oss">
              Om Rädda Djuren-klubben</nuxt-link
            >
          </li>
        </ul>
      </div>
      <div class="max-w-[337px] pt-10 text-left md:pt-0">
        <div class="justify-left mb-2 flex w-full">
          <span
            class="footer-logo inline-block h-[45px] w-[112px] text-[#00B4D2]"
            :style="{
              '-webkit-mask-image': `url(${footerLogoUrl})`,
              'mask-image': `url(${footerLogoUrl})`,
            }"
            aria-label="Djurens Rätt"
            role="img"
          />
        </div>
        <div>
          <ContentfulRichText
            v-if="footerLogotypeTextDoc"
            class="text-md mt-5 [&_a]:text-purple-dark [&_a]:underline"
            :document="footerLogotypeTextDoc"
          />
          <div
            v-else-if="footerLogotypeTextHtml"
            class="text-md mt-5"
            v-html="footerLogotypeTextHtml"
          ></div>
        </div>
      </div>
    </div>

    <!-- <div
      class="second-block mx-5 mb-10 block border-b-2 border-l-0 border-r-0 border-t-2 border-solid border-purple-lightest md:block"
    >
      <div
        class="social mx-auto my-10 flex max-w-[250px] justify-around md:my-20 md:justify-center"
      >
        <a
          v-for="(media, i) in socialmedia"
          :key="i"
          class="m-4 h-10 w-10 transition-all duration-500 ease-in-out hover:scale-105"
          :href="media.url"
        >
          <span
            class="social-icon block h-10 w-10 text-[#5F4198]"
            :style="{
              '-webkit-mask-image': `url(${media.img})`,
              'mask-image': `url(${media.img})`,
            }"
            aria-hidden="true"
          />
        </a>
      </div>
    </div> -->

    <div
      class="second-block md:border-purple-LIGHTEST mx-8 pb-10 md:mx-0 md:flex md:justify-evenly md:px-10 md:py-10"
    >
      <div class="mb-10 md:max-w-[20%]">
        <h4 class="mb-5 pb-2 font-headline text-h3">Kontakta oss</h4>
        <ContentfulRichText v-if="footerContact" class="text-md" :document="footerContact" />
      </div>
      <div class="container__middle mb-10">
        <h4 class="mb-5 pb-2 font-headline text-h3">Snabblänkar</h4>
        <ul class="flex flex-col">
          <li
            v-for="(link, i) in quicklinks"
            :key="i"
            class="before:duration-400 relative mb-5 pl-5 font-body font-bold leading-[21px] text-purple-dark-base before:absolute before:left-0 before:top-1 before:h-2 before:w-2 before:rotate-[-45deg] before:rounded-sm before:border-b-2 before:border-r-2 before:border-solid before:border-purple-dark-base before:transition-all before:content-[''] hover:before:translate-x-0.5 hover:before:translate-x-0.5"
          >
            <nuxt-link class="link" :to="link.url">{{ link.label }}</nuxt-link>
          </li>
          <li
            class="before:duration-400 relative mb-5 pl-5 font-body font-bold leading-[21px] text-purple-dark-base before:absolute before:left-0 before:top-1 before:h-2 before:w-2 before:rotate-[-45deg] before:rounded-sm before:border-b-2 before:border-r-2 before:border-solid before:border-purple-dark-base before:transition-all before:content-[''] hover:before:translate-x-0.5 hover:before:translate-x-0.5"
          >
            <a href="#" class="cky-banner-element">Hantera kakor</a>
          </li>
        </ul>
      </div>
      <div class="container__last">
        <h4 class="mb-5 pb-2 font-headline text-h3">Besök gärna</h4>
        <ul class="flex flex-col">
          <li
            v-for="(link, i) in visitlinks"
            :key="i"
            class="before:duration-400 relative mb-5 pl-5 font-body font-bold leading-[21px] text-purple-dark-base before:absolute before:left-0 before:top-1 before:h-2 before:w-2 before:rotate-[-45deg] before:rounded-sm before:border-b-2 before:border-r-2 before:border-solid before:border-purple-dark-base before:transition-all before:content-[''] hover:before:translate-x-0.5 hover:before:translate-x-0.5"
          >
            <nuxt-link class="link" :to="link.url">{{ link.label }}</nuxt-link>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="third-block mb-10 w-full border-l-0 border-r-0 border-t border-solid border-purple-lightest px-5 md:mb-10 md:block md:p-0 md:px-4"
    >
      <div class="social my-10 flex justify-around md:my-10 md:justify-center">
        <a
          v-for="(media, i) in socialmedia"
          :key="i"
          class="m-4 h-10 w-10 transition-all duration-500 ease-in-out hover:scale-105"
          :href="media.url"
        >
          <span
            class="social-icon block h-10 w-10 text-[#5F4198]"
            :style="{
              '-webkit-mask-image': `url(${media.img})`,
              'mask-image': `url(${media.img})`,
            }"
            aria-hidden="true"
          />
        </a>
      </div>
    </div>
    <div class="my-10 px-5 text-center md:mb-20 md:px-10">
      <p class="hidden md:block">
        Allt innehåll &copy; {{ new Date().getFullYear() }}
        Rädda Djuren-klubben om inte annat anges.
      </p>
      <p class="block md:hidden">
        Allt innehåll &copy; {{ new Date().getFullYear() }} <br />
        Rädda Djuren-klubben om inte annat anges.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Document } from '@contentful/rich-text-types'
import type { Footer as FooterType, ContentfulEntry } from '@/types/contentful'
import { fixImageUrlProtocol } from '@/utils/contentfulHelpers'

interface LinkItem {
  label: string
  url: string
}

const visitlinks: LinkItem[] = [
  { label: 'Webbshop', url: 'https://shop.djurensratt.se/collections/barn' },
  { label: 'Djurens Rätt', url: 'https://www.djurensratt.se' },
  { label: 'Välj Vego', url: 'https://www.valjvego.se' },
]

const quicklinks: LinkItem[] = [
  {
    label: 'Ge bort ett medlemskap',
    url: '/medlem',
  },
  {
    label: 'För vuxna',
    url: '/vuxen',
  },
  {
    label: 'Tidningen Klubbnytt',
    url: '/klubbnytt/',
  },
  {
    label: 'Vanliga frågor',
    url: '/vuxen/for-vuxna/vanliga-fragor',
  },
]

const socialmedia = [
  {
    altText: 'instagram',
    url: 'https://www.instagram.com/raddadjurenklubben',
    img: '/images/instagram-logo.svg',
  },
  {
    altText: 'facebook',
    url: 'https://www.facebook.com/RaddaDjuren',
    img: '/images/facebook.svg',
  },
  {
    altText: 'tiktok',
    url: 'https://www.tiktok.com/@raddadjurenklubben',
    img: '/images/tik-tok-logo.svg',
  },
]

// Fetch footer via cached API route (1-hour server cache) to avoid
// a Contentful call on every SSR request, especially 404 error pages.
const { data: footerData } = await useFetch('/api/footer', {
  key: 'footer-settings',
})

const footer = computed(
  () => footerData.value as unknown as (FooterType & { includes?: any }) | null,
)
const footerIncludes = computed(() => footer.value?.includes)

// Resolve linked entry by id from includes
function resolveEntryById<T = any>(id?: string | null) {
  if (!id || !footerIncludes.value?.Entry) return null
  return footerIncludes.value.Entry.find((e: ContentfulEntry) => e.sys?.id === id) as
    | ContentfulEntry<T>
    | undefined
}

// Resolve CTA props for CtaBanner
const ctaProps = computed(() => {
  const ctaLink = (footer.value as any)?.fields?.cta
  const ctaId = ctaLink?.sys?.id as string | undefined
  const cta = resolveEntryById<any>(ctaId)
  if (!cta) return null

  // Return the full CTA entry with includes for CtaBanner to process
  return {
    ...cta,
    includes: footerIncludes.value,
  }
})

// Footer content fields
const footerBody = computed(() => (footer.value as any)?.fields?.body as Document | undefined)
const footerContact = computed(() => (footer.value as any)?.fields?.contact as Document | undefined)
const footerLogotypeTextDoc = computed(() => {
  const value = (footer.value as any)?.fields?.logotypeText as any
  if (value && typeof value === 'object' && 'nodeType' in value) {
    return value as Document
  }
  return undefined
})

const footerLogotypeTextHtml = computed(() => {
  const value = (footer.value as any)?.fields?.logotypeText as any
  if (typeof value === 'string') return value
  return undefined
})
const footerLogoUrl = computed(() => {
  const logoLink = (footer.value as any)?.fields?.cloudinaryLogotype
  if (!logoLink) return ''
  return fixImageUrlProtocol(logoLink[0]?.url) || '/images/logo.svg'
})
</script>

<style scoped>
.footer-logo {
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
}
.social-icon {
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
}
</style>
